import React from 'react';
import { StyleSheet, Text, Platform, View } from 'react-native';
import { Tile, Theme } from 'fitbeat.react-native-components';
import { translate } from 'react-i18next';

class TrackingNoData extends React.PureComponent {
    render() {
        const { t } = this.props;
        return (
            <View style={styles.mainContainer}>
                <Tile customStyle={styles.container}>
                    <Text style={styles.subtitle}>{t('noData')}</Text>
                </Tile>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    mainContainer: {
        padding: 10,
        backgroundColor: Theme.CHARCOAL
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        borderRadius: 8,
        borderColor: 'grey',
        borderWidth: 1,
        ...Platform.select({
            web: {
                paddingVertical: 0,
            },
        }),
    },
    subtitle: {
        color: '#B8B8B8',
        fontSize: 14,
        fontWeight: '300',
        letterSpacing: 0,
        lineHeight: 20,
        marginTop: 10,
        marginBottom: 10,
    },
});

export default translate(['workoutHistory'])(TrackingNoData);
